export default __webpack_public_path__ + "static/top-25-2021-1557f4e66fb82a626b767ff2d9f1eb65.png";